import axios from 'axios';
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_CONFIGURATION}`;

const request = async (method, endpoint, data = null) => {
    const url = `${BASE_URL}${endpoint}`;
    try {
        const headers = await headers_get();
        return await axios({ method, url, data, headers });
    } catch (error) {
        console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
        throw error;
    }
};

// **MODULES**
export const modules_get = () => request("get", "/od/modules");
export const modules_post = (data) => request("post", "/od/modules", data);
export const modules_put = (id, data) => request("put", `/od/modules/${id}`, data);
export const modules_delete = (id) => request("delete", `/od/modules/${id}`);

// **SUBMODULES**
export const modules_submodule_post = (id, data) => request("post", `/od/modules/${id}/submodules`, data);
export const modules_submodule_put = (id, ids, data) => request("put", `/od/modules/${id}/submodules/${ids}`, data);
export const modules_submodule_delete = (id, ids) => request("delete", `/od/modules/${id}/submodules/${ids}`);

// **SPECIAL ACTIONS**
export const modules_special_action_post = (id, ids, data) => request("post", `/od/modules/${id}/submodules/${ids}/special-action`, data);
export const modules_special_action_put = (id, ids, ida, data) => request("put", `/od/modules/${id}/submodules/${ids}/special-action/${ida}`, data);
export const modules_special_action_delete = (id, ids, ida) => request("delete", `/od/modules/${id}/submodules/${ids}/special-action/${ida}`);
